
<div class="col-xl-12">
	<h1 mat-dialog-title>{{data.title}}</h1>
	<div mat-dialog-content>
		<app-custom-scheduler [personal]="true"></app-custom-scheduler>
	</div>
	<div mat-dialog-actions>
		<button color="danger" mat-raised-button (click)="closeModal(undefined)">{{'Close' | translate}}</button>
	</div>
</div>